import { useSede } from '@/lib/sede';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Building2 } from 'lucide-react';

export const SedeSelector = () => {
  const { sedi, sedeAttiva, setSedeAttiva, tutteLeSedi } = useSede();

  if (sedi.length <= 1 && !tutteLeSedi) return null;

  const onChange = (value) => {
    setSedeAttiva(value);
    window.location.reload();
  };

  return (
    <div className="flex items-center gap-1.5" data-testid="sede-selector">
      <Building2 className="w-4 h-4 text-brand hidden sm:block" />
      <Select value={sedeAttiva} onValueChange={onChange}>
        <SelectTrigger className="h-8 w-[170px] text-xs border-slate-200" data-testid="sede-selector-trigger">
          <SelectValue placeholder="Sede" />
        </SelectTrigger>
        <SelectContent>
          {tutteLeSedi && <SelectItem value="tutte" data-testid="sede-option-tutte">Tutte le sedi</SelectItem>}
          {sedi.map(s => (
            <SelectItem key={s.id} value={s.id} data-testid={`sede-option-${s.id}`}>
              {s.nome}{s.ospiti_presenti != null ? ` (${s.ospiti_presenti})` : ''}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SedeSelector;
